export default __webpack_public_path__ + "static/media/fab-logo-powered-by.fa1e8769.png";